import React, { useEffect, useRef } from "react";
import { CELL_SIZE, THEME_TILES_MAP } from "../../helpers/consts";
import MapCell from "./MapCell";
import { useRecoilValue } from "recoil";
import { selectedPlacementAtom } from "../../atoms/selectedPlacementAtom";
import styles from "./LevelBackgroundTilesLayer.module.css";
import { spriteSheetImageAtom } from "../../atoms/spriteSheetImageAtom";

export default function LevelBackgroundTilesLayer({ level }) {
  const placementSelection = useRecoilValue(selectedPlacementAtom);
  const spriteSheetImage = useRecoilValue(spriteSheetImageAtom);
  const widthWithWalls = level.tilesWidth + 1;
  const heightWithWalls = level.tilesHeight + 1;
  const tiles = THEME_TILES_MAP[level.theme];
  const backgroundTilesCanvas = useRef(null);

  useEffect(() => {
    const ctx = backgroundTilesCanvas.current.getContext("2d");
    ctx.clearRect(
      0,
      0,
      backgroundTilesCanvas.current.width,
      backgroundTilesCanvas.current.height
    );
    for (let y = 0; y <= heightWithWalls; y++) {
      for (let x = 0; x <= widthWithWalls; x++) {
        // // Skip Bottom Left and Bottom Right for intentional blank tiles in those corners
        if (y === heightWithWalls) {
          if (x === 0 || x === widthWithWalls) {
            continue;
          }
        }

        let frameCoord = tiles.FLOOR;
        if (y === 0) {
          frameCoord = tiles.TOP;
        }
        if (x === 0) {
          frameCoord = tiles.LEFT;
        }
        if (x === widthWithWalls) {
          frameCoord = tiles.RIGHT;
        }
        if (y === heightWithWalls) {
          frameCoord = tiles.BOTTOM;
        }

        const size = 16;
        const tileSheetX = Number(frameCoord.split("x")[0]);
        const tileSheetY = Number(frameCoord.split("x")[1]);

        ctx.drawImage(
          spriteSheetImage,
          tileSheetX * CELL_SIZE, // Left X corner of frame
          tileSheetY * CELL_SIZE, // Top Y corner of frame
          size, //How much to crop from the sprite sheet (X)
          size, //How much to crop from the sprite sheet (Y)
          x * size, //Where to place this on canvas tag X (0)
          y * size, //Where to place this on canvas tag Y (0)
          size, //How large to scale it (X)
          size //How large to scale it (Y)
        );
      }
    }
  }, [spriteSheetImage, heightWithWalls, widthWithWalls, tiles]);

  let canvases = [];
  for (let y = 0; y <= heightWithWalls; y++) {
    for (let x = 0; x <= widthWithWalls; x++) {
      // Skip Bottom Left and Bottom Right for intentional blank tiles in those corners
      if (y === heightWithWalls) {
        if (x === 0 || x === widthWithWalls) {
          continue;
        }
      }

      let frameCoord = tiles.FLOOR;
      if (x === 0) {
        frameCoord = tiles.LEFT;
      }
      if (x === widthWithWalls) {
        frameCoord = tiles.RIGHT;
      }
      if (y === 0) {
        frameCoord = tiles.TOP;
      }
      if (y === heightWithWalls) {
        frameCoord = tiles.BOTTOM;
      }

      // Create a tile for each x/y coord
      canvases.push(
        <MapCell
          key={x + "_" + y}
          x={x}
          y={y}
          isEditable={level.isEditMode}
          frameCoord={frameCoord}
          onClick={() => {
            level.editor.handlePlacementClick(x, y, placementSelection);
          }}
        />
      );
    }
  }

  return (
    <div className={styles.mapBoard}>
      <canvas
        width={(level.tilesWidth + 2) * 16 + "px"}
        height={(level.tilesHeight + 2) * 16 + "px"}
        ref={backgroundTilesCanvas}
      ></canvas>
      {canvases}
    </div>
  );
}
